import React, { useState, useRef, useEffect } from 'react';
import styles from './aea-collapse.module.scss';
import { FaAngleDown, FaAngleUp } from "react-icons/fa";

interface ISingleCollapse{
    title: string;
    description?: string;
    isOpen: boolean;
    keepOpen?: boolean;
    sub?: boolean;
    idTitle?: string;
    idIcon?: string;
}

const SingleCollapse: React.FC<ISingleCollapse> = (props) => { 
    const [isOpen, setIsOpen] = useState(props.isOpen);
    
    useEffect(() => {
        if(props.keepOpen && isOpen) setIsOpen(true)
        else setIsOpen(props.isOpen)
    }, [props.isOpen])
    
    const divRef = useRef<HTMLDivElement>(null);

    const toggle = () => setIsOpen(!isOpen);    

    const getTitle = () => {
        let headerClass = styles.titleRowOnly;
        let header =  <h5 id={props.idTitle || ''}>{props.title}</h5>;
        if(props.sub){
            header = <h6>{props.title}</h6>
        }
        
        if(props.description !== undefined && props.description !== null){
            headerClass = styles.titleRow;
            header =  <><h5 >{props.title}</h5><h6>{props.description}</h6></>;
        }
        return <div className={headerClass}>{header}</div>;
    }    
    const getItemRender = () =>{        
        let result = props.children;
        if(props.title !== undefined && props.title !== null){
            result = (<>
                <div onClick={()=>toggle()} className={styles.titleContainer}  > 
                    {getTitle()}
                    {isOpen ? <FaAngleUp id={props.idIcon || ''} /> : <FaAngleDown id={props.idIcon || ''} />}
                </div>
                <div ref={divRef} className={isOpen ? styles.contentContainer : styles.contentContainerCollapse}>
                    {props.children}
                </div>
            </>);
        }
        return result;
    }    
    const render = () => {        
        return (            
            <div className={styles.container}>
                {getItemRender()}
            </div>
        );
    }
    return render();
}

export default SingleCollapse;